import { Textarea } from '@chakra-ui/react'
import React from 'react'

import { Helper } from '../Helper/Helper'

interface InputTextAreaProps {
  dark?: boolean
  defaultValue?: string
  disabled?: boolean
  error?: boolean
  helper?: string
  lines?: number
  maxLength?: number
  /** Sets the number of lines the text area starts with **/
  name?: string
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  onValueChange?: (value: string) => void
  placeholder?: string
  resize?: ResizeType
  success?: boolean
  variant?: string
}

type ResizeType = 'none' | 'vertical' | 'horizontal'
const defaultLines = 3

export const InputTextArea = React.forwardRef<
  HTMLTextAreaElement,
  InputTextAreaProps
>(
  (
    {
      error,
      dark,
      success,
      defaultValue = '',
      disabled = false,
      helper,
      name,
      //eslint-disable-next-line @typescript-eslint/no-empty-function
      onValueChange = () => {},
      resize = 'none',
      lines = defaultLines,
      placeholder = '',
      maxLength,
      onChange,
      variant,
    },
    ref,
  ) => {
    return (
      <>
        <Textarea
          ref={ref}
          defaultValue={defaultValue}
          disabled={disabled}
          error={error}
          height={`${(lines || defaultLines) * 22 + 16}px`}
          lines={lines}
          maxLength={maxLength}
          maxWidth="100%"
          minHeight={10}
          name={name}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            onValueChange(e.target.value)
            onChange?.(e)
          }}
          opacity={1}
          padding={2}
          placeholder={placeholder}
          resize={resize}
          success={success}
          variant={variant}
        />
        {helper && (
          <Helper error={error} inverted={dark} success={success}>
            {helper}
          </Helper>
        )}
      </>
    )
  },
)

InputTextArea.displayName = 'InputTextArea'
